import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { FacadeService } from '../services/facade.service';
import { Service } from 'src/app/shared/models/service';

@Injectable({
	providedIn: 'root'
})
export class InfosasGuard implements CanActivate {
	service: Service;
	constructor(private facade: FacadeService, private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		this.service = this.facade.dataStorageService.getService();

		if (this.service.handleInfosas) {
			return true;
		} else {
			this.router.navigate(['dashboard']);
			return false;
		}
	}
}
